import { Component, Input } from '@angular/core';

import { Colors, colorsEnum } from '../../../shared/enums';

@Component({
    selector: 'cmn-tag',
    templateUrl: './tag.component.html',
    styleUrls: [ './tag.component.scss' ],
})

export class TagComponent {
    @Input() public readonly label: string;
    @Input() public readonly color: Colors;
    @Input() public readonly category: string;
    @Input() public readonly background: Colors = colorsEnum.light;
}
